import {
	AccordionActions,
	AccordionDetails,
	AccordionSummary,
	Accordion,
	Box,
	Button,
	Typography,
	Container,
	Stack,
	Grid,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../providers/AuthenticationProvider";
import { useNetwork } from "../providers/NetworkProvider";
import { useSnackbar } from "../providers/SnackbarProvider";
import { useEffect } from "react";
import { useTranslationProvider } from "../providers/TranslationProvider";
import { PriceType } from "../types/user";
import { Element } from "react-scroll";

const PricingPlan = () => {
	const { makePost } = useNetwork();
	const { t } = useTranslation();
	const { language } = useTranslationProvider();
	const { profile, user } = useAuth();

	function redirect(url: string) {
		window.location.href = url;
	}
	const navigate = useNavigate();

	const { signWithEmailAndPassword, recoverPassword, setTemporaryPassword } =
		useAuth();
	const { openLoadingSnackbar, closeLoadingSnackbar, openSnackbar } =
		useSnackbar();
	let location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const sessionId = queryParams.get("session_id");
	const referralCode = queryParams.get("code");
	const discout = referralCode ? 10 : 0;
	useEffect(() => {
		if (sessionId == null) return;
		(async () => {
			try {
				openLoadingSnackbar();
				const response = await makePost(
					"payments/stripe/successSession",
					{
						sessionId: sessionId,
					}
				);
				console.log(response);
				// @ts-ignore
				window.fbq("track", "Purchase", {
					currency: "USD",
					value: 30.0,
				});
				if (response.data.email == null) {
					closeLoadingSnackbar();
					return;
				}

				const randomPassword = Math.random().toString(36).slice(-8);
				const email = response.data.email;
				const uid = await signWithEmailAndPassword(
					email,
					randomPassword,
					false
				);
				openLoadingSnackbar();
				const response_ = await makePost(
					"payments/stripe/completeSubscription",
					{
						sessionId: sessionId,
						uid: uid,
					}
				);
				// save password
				setTemporaryPassword(randomPassword);
				if (response_.status == 200) await recoverPassword(email);
				console.log(response_.data);
				closeLoadingSnackbar();
				navigate("/reserved/firstPaymentCompleted");
			} catch (error) {
				// TOFO: check this part; what to do in the case the payemnt made it thourgh but we could not complete registgration (e.g. email unavailable)
				closeLoadingSnackbar();
				openSnackbar("Error", "Something went wrong", "error");
			}
		})();
	}, [sessionId]);

	const handlePurchase = async (type: PriceType) => {
		const isProduction = process.env.REACT_APP_IS_PRODUCTION === "true";
		const productionPriceIds: { [key in PriceType]: string } = {
			basic: "price_1PdWqsANVtnBUNBJnL0rrT0j",
			premium: "price_1PdWwOANVtnBUNBJfqIpVhgd",
			enterprise: "price_1PdWvtANVtnBUNBJ9c2RZE8z",
		};
		const testPriceIds: { [key in PriceType]: string } = {
			basic: "price_1P7JXKANVtnBUNBJ3gFChoXP",
			premium: "price_1PD30pANVtnBUNBJbL4qogjv",
			enterprise: "price_1PD31LANVtnBUNBJRc4Kad7S",
		};
		const priceId = isProduction
			? productionPriceIds[type]
			: testPriceIds[type];
		try {
			openLoadingSnackbar();
			const referralCode = queryParams.get("code");
			const response = await makePost("payments/stripe/stripeSession", {
				priceId: priceId,
				referralCode: referralCode,
				customerId: profile == null ? null : profile.customerId,
			});
			window.location.href = response.data.url;
		} catch (err) {
			console.log(err);
		} finally {
			closeLoadingSnackbar();
		}
	};

	return (
		<Box
			sx={{
				marginTop: "8vh",
				padding: window.innerWidth > 600 ? "2vh 0 10vh" : "2vh 1vh",
			}}
		>
			<Container>
				<Element name="pricing"></Element>
				<Typography
					variant="h3"
					align="center"
					sx={{
						fontFamily: "Work Sans !important",
						fontWeight: "600",
						fontSize: window.innerWidth < 600 ? "32px" : "50px",
					}}
				>
					{t("pricingPlans.title")}
				</Typography>
				<Typography
					mt={2}
					variant="h6"
					align="center"
					sx={{
						fontFamily: "Work Sans !important",
						fontWeight: "300",
						fontSize: window.innerWidth < 600 ? "16px" : "18px",
					}}
				>
					{t("pricingPlans.discount")}
				</Typography>

				<Grid container spacing={0} sx={{ marginTop: "8vh" }}>
					<Grid
						md={4}
						xs={12}
						sx={{
							padding: "20px 0",
						}}
					>
						<Box className="card">
							<div className="titleCard">
								<div style={{ marginTop: "-24px" }}>
									<span
										className="badge"
										style={{
											fontSize: "20px",
											fontWeight: "bold",
											backgroundColor: "#131721",
											borderRadius: "100px",
											display: "inline",
											padding: "4px 16px",
										}}
									>
										{t("pricingPlans.basic")}
									</span>
								</div>
								<del
									style={{
										opacity: "70%",
										fontSize: "20px",
									}}
								>
									240€
								</del>{" "}
								{(215 - (215 * discout) / 100).toFixed(
									discout == 0 ? 0 : 2
								)}
								€
							</div>
							<div className="textCard">
								{t("pricingPlans.basic.ideal")}{" "}
								<b
									style={{
										color: "rgb(42, 212, 212)",
									}}
								>
									{t("pricingPlans.basic.follow")}
								</b>{" "}
								{t("pricingPlans.basic.choice")}
							</div>
							<ul style={{ listStyleType: "none" }}>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.notification")}
								</li>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.liveSignals")}
								</li>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.advanceTradersHistory")}
								</li>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.analysis")}
								</li>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.oneClickCopytrader")}
								</li>
							</ul>
							<Button
								variant="contained"
								color="secondary"
								sx={{
									textTransform: "none",
									margin: "16px 0 8px 0",
									fontWeight: "600",
									borderRadius: "100px",
									width: "100%",
									fontSize: "18px",
								}}
								onClick={async () => {
									await handlePurchase("basic");
								}}
							>
								{t("pricingPlans.startNow")}
							</Button>
						</Box>
					</Grid>

					<Grid
						md={4}
						xs={12}
						sx={{
							padding: "20px 0",
						}}
					>
						<Box
							className="card bg-green"
							sx={{
								transform:
									window.innerWidth > 600
										? "scale(1.15)"
										: "",
								margin: window.innerWidth > 600 ? "0 20px" : "",
							}}
						>
							<div className="titleCard">
								<div style={{ marginTop: "-24px" }}>
									<span
										className="badge"
										style={{
											fontSize: "20px",
											fontWeight: "bold",
											backgroundColor: "#131721",
											borderRadius: "100px",
											display: "inline",
											padding: "4px 16px",
										}}
									>
										{t("pricingPlans.premium")}
									</span>
								</div>
								<del
									style={{
										opacity: "70%",
										fontSize: "20px",
									}}
								>
									284€
								</del>{" "}
								{(250 - (250 * discout) / 100).toFixed(
									discout == 0 ? 0 : 2
								)}
								€
							</div>
							<div className="textCard">
								{t("pricingPlans.premium.mostPopuler")}{" "}
								<b
									style={{
										color: "rgb(42, 212, 212)",
									}}
								>
									{t("pricingPlans.premium.follow3")}
								</b>
							</div>
							<ul style={{ listStyleType: "none" }}>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.notification")}
								</li>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.liveSignals")}
								</li>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.advanceTradersHistory")}
								</li>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.analysis")}
								</li>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.oneClickCopytrader")}
								</li>
							</ul>

							<Button
								variant="contained"
								color="primary"
								sx={{
									textTransform: "none",
									margin: "16px 0 8px 0",
									fontWeight: "600",
									borderRadius: "100px",
									width: "100%",
									fontSize: "18px",
								}}
								onClick={async () => {
									await handlePurchase("premium");
								}}
							>
								{t("pricingPlans.startNow")}
							</Button>
						</Box>
					</Grid>

					<Grid
						md={4}
						xs={12}
						sx={{
							padding: "20px 0",
						}}
					>
						<Box className="card">
							<div className="titleCard">
								<div style={{ marginTop: "-24px" }}>
									<span
										className="badge"
										style={{
											fontSize: "20px",
											fontWeight: "bold",
											backgroundColor: "#131721",
											borderRadius: "100px",
											display: "inline",
											padding: "4px 16px",
										}}
									>
										Enterprise
									</span>
								</div>
								<del
									style={{
										opacity: "70%",
										fontSize: "20px",
									}}
								>
									327€
								</del>{" "}
								{(285 - (285 * discout) / 100).toFixed(
									discout == 0 ? 0 : 2
								)}
								€
							</div>
							<div className="textCard">
								{t("pricingPlans.enterprise.experts")}{" "}
								<b
									style={{
										color: "rgb(42, 212, 212)",
									}}
								>
									{t("pricingPlans.enterprise.follow5")}
								</b>
							</div>
							<ul style={{ listStyleType: "none" }}>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.notification")}
								</li>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.liveSignals")}
								</li>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.advanceTradersHistory")}
								</li>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.analysis")}
								</li>
								<li style={{ position: "relative" }}>
									<span
										style={{
											position: "absolute",
											left: "-32px",
											top: "10px",
											fontSize: "16px",
											lineHeight: "0",
										}}
									>
										☑️
									</span>
									{t("pricingPlans.oneClickCopytrader")}
								</li>
							</ul>

							<Button
								variant="contained"
								color="secondary"
								sx={{
									textTransform: "none",
									margin: "16px 0 8px 0",
									fontWeight: "600",
									borderRadius: "100px",
									width: "100%",
									fontSize: "18px",
								}}
								onClick={async () => {
									await handlePurchase("enterprise");
								}}
							>
								{t("pricingPlans.startNow")}
							</Button>
						</Box>
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
};

export default PricingPlan;
